import { render } from "./TeamPage.vue?vue&type=template&id=99135a6a"
import script from "./TeamPage.vue?vue&type=script&lang=js"
export * from "./TeamPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__